import {
  FormFieldSelectOneEntityDocument
} from '../Form';

import {
  // Select
  FilterRenderSelectOneEntityDocument,
  FilterCreatorSelectOneEntityDocument,
} from '../Filters';

export default {
  Render(props) {
    const {
      fieldName,
      taxonomyType,
      overrideParams = {},
      fieldsRequired
    } = props;
    const _taxonomyType = taxonomyType?.data || taxonomyType;
    const title = _taxonomyType?.name;
    // const design = _taxonomyType?.style?.design
    const _fieldName = fieldName || _taxonomyType?.nameSlug;
    const param = { ..._taxonomyType?.param, ...overrideParams };

    return (
      <FormFieldSelectOneEntityDocument 
        name={_fieldName}
        title={title}
        fieldsRequired={fieldsRequired}
        {...param}
        {...props}
        entitySlug={param?.entityNameSlug} // retrocompatible
      />
    );
  },

  RenderFilterParam(params) {
    return <FilterCreatorSelectOneEntityDocument {...params} />
  },

  RenderFilterPreview({ values }) {
    return <FilterRenderSelectOneEntityDocument values={values} DataTypeRender={this.Render} />
  },

  RenderInputParams: ({ values, param }) => (
    <FormFieldSelectOneEntityDocument
      name="param.entityNameSlug" // TODO migrate entitySlug to entityNameSlug
      entitySlug="entities"
      title="Entidad"
      optionsMapper={
        (docs) => 
          docs.map((option) => ({
            value: option?.data?.nameSlug,
            label: option?.data?.name,
          }))
      }
    />
  ),
  
  RenderShowConditionParams: ({ values, taxonomyToWatch }) => (null),
  
  RenderStyleParams: ({ values }) => (null),
  
  RenderTaxonomyTypePreview: ({ values, formFieldProps }) => {
    const entitySlug = values?.param?.entitySlug || values?.param?.entityNameSlug; // retrocompatible
    return (
      <FormFieldSelectOneEntityDocument
        entitySlug={entitySlug}
        {...formFieldProps}
      />
    );
  }
}